import React from 'react';
import PropTypes from 'prop-types';
import MainNavLinks from './MainNavLinks';

const defaultYear = '2020';
const footerCSS = {
  fontFamily:
    'Helvetica, "Helvetica Neue", Futura, Verdana, Geneva, sans-serif',
  padding: '20px 54px',
  textAlign: 'center',
  fontSize: '0.8rem',
  color: '#000',
  borderTop: '1px solid #f0f0f0',
};
const linkCSS = {
  color: '#404d5b',
  textDecoration: 'underline',
};

// eslint-disable-next-line func-names
const Footer = function (props) {
  const { year, label } = props;
  const displayYear = year === '' || year === undefined ? defaultYear : year;
  const displayLabel =
    label === '' || label === undefined
      ? 'University copyright information'
      : label;
  return (
    <footer
      role='contentinfo'
      style={footerCSS}
      aria-label={displayLabel}
      id='umnFooter'
    >
      <MainNavLinks mode='footer' />
      <p>
        &copy;
        <span className='year'>{displayYear}</span>
        <span> </span>
        Regents of the University of Minnesota. All rights reserved. The
        University of Minnesota is an equal opportunity educator and employer.
        <span> </span>
        <a href='http://privacy.umn.edu' style={linkCSS}>
          Privacy Statement
        </a>
        <div className='row'>
          <div className='col'>
            <a
              href='https://z.umn.edu/report-accessibility-issue'
              style={linkCSS}
            >
              Report Web Accessibility Issues
            </a>
          </div>
        </div>
      </p>
    </footer>
  );
};

Footer.propTypes = {
  year: PropTypes.string,
  label: PropTypes.string,
};

Footer.defaultProps = {
  year: '2020',
  label: 'University copyright information',
};

export default Footer;
